import {
  GetComponentResponse,
  RootCpntIchr,
  GetEdhPrtclAttribute,
} from "../../services/component/get-component/GetComponentResponse";
import { EdhProtocolCombination } from "../../services/data-list/get-edh-protocol-combination-list/GetEdhProtocolCombinationListResponse";
import { ErrorMessage } from "../../util";
import { Option } from "../../util/option";

export type ComponentDetailPageState = {
  searchResult: GetComponentResponse;
  edhProtocolCombination: EdhProtocolCombination[];
  dataList: DataList;
};

export type PicAddressSpreadsheetState = {
  results: RootCpntIchr[];
};

export type EdhProtocolSpreadsheetState = {
  edhPrtcl: SpreadsheetEdhPrtcl[];
  godFlg: string;
  editCell: EditCell;
  dataList: DataList;
};

export type SpreadsheetEdhPrtcl = {
  isChangedPrd: boolean;
  isChangedStg: boolean;
  rowIdx: number;
  edhPrtclInfo: EdhPrtclAndPjtInfo;
  isEditableAttr: boolean;

  // For ErrorInfo
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};
export type EditCell = {
  [key: string]: {
    isDirty: boolean;
    initialValue: string;
    currentValue: string;
    isError: boolean;
  };
};

export type PageNewState =
  | ComponentDetailPageState
  | ((prevState: ComponentDetailPageState) => ComponentDetailPageState);

export type EdhPrtclAttribute = GetEdhPrtclAttribute & {
  isEditableAttr: boolean;
};

export type EdhPrtclAndPjtInfo = {
  cpntEdhPrtclMngDelFlg: string;
  inOutTypeCd: string;
  edhPrtclTypeCd: string;
  updateDateTimecpntEdhPrtclMngEdh: string;
  edhPrtclDisplayName: string;
  godFlg: string;
  inProgressCmpProjectId: string;
  inProgressCmpProjectName: string;
  waitingCmpProjectName: string;
  inProgressCmpProjectReqType: string;
  stgOnlyFlg: string;
  cmnt: string;
  updateDateTimeCmnt: string;
  designStatusName: string;
  designStatus: string;
  updateDateTimeDesignStatus: string;
  stgDeployStatusName: string;
  prdDeployStatusName: string;
  edhPrtclAttributeList: EdhPrtclAttribute[];
};

export type DataList = {
  cpntOwnType: Option[];
  cpntAlctnType: Option[];
  clodSrvc: Option[];
  clodSrvcRgn: Option[];
  edhProtcolList: Option[];
  startMethod: Option[];
  inboundNotificator: Option[];
  outboundNotificator: Option[];
  dynamicEdhProtocolList: Option[];
  inDefCommonFlagType: Option[];
};
